let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aBU6D")).then(() => parcelRequire('iizuB'));